import React from 'react';
import styled from 'styled-components';

interface Status {
  id: number;
  name: string;
  color?: string;
}

interface StatusFilterTabsProps {
  statuses: Status[];
  selectedStatuses: string[];
  onChange: (statusIds: string[]) => void;
}

const TabsContainer = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 4px 0;
  flex-wrap: wrap;

  /* Hide scrollbar but allow scrolling */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 767px) {
    padding-bottom: 8px;
  }
`;

const Tab = styled.button<{ $isActive: boolean; $tabColor?: string }>`
  display: inline-flex;
  align-items: center;
  padding: 10px 20px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;

  ${props => props.$isActive ? `
    background: var(--primary-color);
    color: white;
    border-color: var(--primary-color);
  ` : `
    background: white;
    color: var(--text-secondary);
    border-color: var(--border-color);

    &:hover {
      border-color: var(--primary-color);
      color: var(--primary-color);
    }
  `}
`;

const StatusFilterTabs: React.FC<StatusFilterTabsProps> = ({
  statuses,
  selectedStatuses,
  onChange
}) => {
  const handleToggle = (statusId: string) => {
    if (statusId === '') {
      // "All" button - clear selection
      onChange([]);
    } else {
      // Toggle individual status
      if (selectedStatuses.includes(statusId)) {
        onChange(selectedStatuses.filter(id => id !== statusId));
      } else {
        onChange([...selectedStatuses, statusId]);
      }
    }
  };

  return (
    <TabsContainer>
      <Tab
        $isActive={selectedStatuses.length === 0}
        onClick={() => handleToggle('')}
      >
        הכל
      </Tab>
      {statuses.map(status => (
        <Tab
          key={status.id}
          $isActive={selectedStatuses.includes(status.id.toString())}
          onClick={() => handleToggle(status.id.toString())}
          $tabColor={status.color}
        >
          {status.name}
        </Tab>
      ))}
    </TabsContainer>
  );
};

export default StatusFilterTabs;
